import React, { createContext, useCallback, useContext, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import styled from "styled-components";

const Ctx = createContext({
  startTransition: () => {},
  clearTransition: () => {},
  hasOverlay: false,
});

export function TransitionProvider({ children }) {
  const [overlay, setOverlay] = useState(null);

  const startTransition = useCallback((data) => {
    setOverlay(data);
  }, []);

  const clearTransition = useCallback(() => {
    setOverlay(null);
  }, []);

  return (
    <Ctx.Provider
      value={{ startTransition, clearTransition, hasOverlay: !!overlay }}
    >
      {children}

      <AnimatePresence>
        {overlay && (
          <OverlayRoot key="global-transition-overlay">
            <BgOverlay
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            />
            <FlyImg
              src={overlay.src}
              initial={{
                top: overlay.rect.top,
                left: overlay.rect.left,
                width: overlay.rect.width,
                height: overlay.rect.height,
                borderRadius: 6,
              }}
              animate={{
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                borderRadius: 0,
              }}
              exit={{ opacity: 0, transition: { duration: 0.4 } }}
              transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
            />
          </OverlayRoot>
        )}
      </AnimatePresence>
    </Ctx.Provider>
  );
}

export const useTransitionOverlay = () => useContext(Ctx);

const OverlayRoot = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  pointer-events: none;
`;

const BgOverlay = styled(motion.div)`
  position: absolute;
  inset: 0;
  background: #000;
`;

const FlyImg = styled(motion.img)`
  position: absolute;
  object-fit: cover;
  filter: grayscale(1);
  display: block;
`;
